import React, { useEffect } from "react";
import "../sell-fast-page/info-page.css";

const TERMS = [
  {
    title: "General",
    points: [
      "Advertisers and users are responsible for ensuring that all content — including text, images and graphics — uploaded to AdsOne.lk complies with all applicable laws. AdsOne assumes no responsibility for any illegality or inaccuracy in user-submitted content.",
      "Advertisers guarantee that their content does not violate any copyright, intellectual property rights or other rights of any person or entity, and agree to release AdsOne from all obligations, liabilities and claims arising in connection with the use of the service.",
      "Advertisers agree that their content may be presented through AdsOne.lk's partner sites under the same terms and conditions.",
    ],
  },
  {
    title: "Copyright",
    points: [
      "Advertisers grant AdsOne a perpetual, royalty-free, irrevocable, non-exclusive right and licence to use, reproduce, modify, adapt, publish, translate, create derivative works from, and distribute such content, or incorporate it into any form, medium or technology now known or later developed.",
      "All material on AdsOne.lk — including content, software and services — is the property of AdsOne, its subsidiaries, affiliates and/or third-party licensors. No material on this site may be copied, reproduced, republished, posted, transmitted, stored or distributed without written permission from AdsOne.",
    ],
  },
  {
    title: "Watermarks",
    points: [
      "All images on AdsOne.lk are watermarked to prevent unauthorised use without the advertiser's consent.",
    ],
  },
  {
    title: "Safety & Images",
    points: [
      "AdsOne reserves the right to amend the title of any content for editorial purposes, and reserves the right not to publish images that are irrelevant or that violate AdsOne.lk's policies.",
    ],
  },
  {
    title: "Personal Data",
    points: [
      "AdsOne has the right to cooperate with authorities where content violates the law. Advertiser and user identities may be determined, for example by an ISP. IP addresses may be recorded to ensure compliance with these terms and conditions.",
    ],
  },
  {
    title: "Privacy",
    points: [
      "AdsOne collects information from users and advertisers as a condition of use. Each user and advertiser consents to AdsOne collecting and using this information for administering, supporting and improving AdsOne.lk, including for research, marketing and product development.",
    ],
  },
  {
    title: "Cookies",
    points: [
      "This site uses cookies. You must have cookies enabled for all functionality to work correctly. A cookie is a small data file written to your device when you visit certain websites. Cookies cannot read data off your hard disk, read cookie files from other sites, or identify you personally on their own.",
    ],
  },
  {
    title: "Email Address of Users",
    points: [
      "Users must provide a valid email address before posting advertisements. Email addresses will not be publicly displayed; other users may contact you only through AdsOne.lk's messaging features.",
    ],
  },
  {
    title: "Site Availability",
    points: [
      "AdsOne does not guarantee continuous or secure access to AdsOne.lk. The site is provided 'as is' and as available.",
    ],
  },
  {
    title: "Links to Third-Party Websites",
    points: [
      "AdsOne.lk may contain links to third-party websites. AdsOne is not responsible for third-party content and does not investigate or monitor such sites. Users who leave AdsOne.lk to access third-party sites do so at their own risk.",
    ],
  },
  {
    title: "Paid Content & Services",
    points: [
      "Some content and services on AdsOne.lk require payment, including but not limited to membership packages and ad promotions.",
    ],
  },
  {
    title: "Disclaimer",
    points: [
      "AdsOne assumes no responsibility for the use of AdsOne.lk and disclaims all liability for any injury, claim or damage resulting from errors on the site, inaccessibility of the site, your use of the site or content, or your use of any equipment or software in connection with AdsOne.lk.",
    ],
  },
  {
    title: "Indemnification",
    points: [
      "Advertisers and users agree to indemnify AdsOne and its officers, directors, employees and agents against all losses, expenses, damages and costs, including legal fees, resulting from any violation of these Terms and Conditions.",
    ],
  },
  {
    title: "Modifications",
    points: [
      "AdsOne reserves the right to modify these Terms and Conditions at any time. Changes take effect immediately upon publication on AdsOne.lk. Continued use of the site constitutes acceptance of the updated terms.",
    ],
  },
  {
    title: "Governing Law",
    points: [
      "AdsOne.lk is operated under the laws and regulations of Sri Lanka.",
    ],
  },
];

function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Legal</p>
            <h1 className="info-page__title">Terms &amp; Conditions</h1>
            <p className="info-page__subtitle">
              Please read these Terms and Conditions carefully before using AdsOne.lk.
              By accessing the site you agree to be bound by these terms.
            </p>
          </div>

          {/* Terms body */}
          <div className="info-page__body">
            {TERMS.map((section, i) => (
              <div key={i} className="info-section" style={{ flexDirection: "column", gap: "0.5rem" }}>
                <h3 className="info-section__title" style={{ marginBottom: 0 }}>
                  {i + 1}. {section.title}
                </h3>
                <ul className="info-section__list">
                  {section.points.map((p, j) => (
                    <li key={j} style={{ alignItems: "flex-start" }}>
                      <span style={{ color: "#ed1b24", fontWeight: 700, flexShrink: 0, marginTop: 1 }}>—</span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Last updated */}
          <div style={{ padding: "0 2.5rem 2rem", color: "#94a3b8", fontSize: "0.8125rem" }}>
            Last updated: 2026. For questions contact us at info@adsone.lk
          </div>

        </div>
      </div>
    </div>
  );
}

export default TermsPage;
